<form class="search-bar" (ngSubmit)="submitForm()">
  <input [placeholder]="'common.search' | t" [formControl]="searchControl" />
  <sn-icon-button
    icon="search"
    type="submit"
    [matTooltip]="'common.search' | t"
    color="success"
    class="sn-searchbar__search-button"
  >
  </sn-icon-button>
  <sn-icon-button
    color="danger"
    icon="close"
    [matTooltip]="'common.clearSearch' | t"
    class="sn-searchbar__clear-button"
    (click)="clear()"
  >
  </sn-icon-button>
</form>

<sn-data-list [fetchFn]="loadData" #listElement>
  <sn-infinite-scroll class="overflow-auto">
    <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="listTmpl"></ng-template>
    <ng-template
      [ngIf]="!list.dataSource.data.length && list.dataIsInited"
      [ngIfThen]="notDateFound"
    ></ng-template>
  </sn-infinite-scroll>
</sn-data-list>

<ng-template #listTmpl>
  <sn-member-list [items]="list.dataSource.data" [actions]="memberActions"></sn-member-list>
</ng-template>

<ng-template #notDateFound>
  <div class="no-found">
    <p>{{ 'communication.chat.members.noMembersFound' | t }}</p>
  </div>
</ng-template>
